import { Group } from "@mantine/core";
import TableSearch from "./TableSearch";
import TableColumns from "./columns/TableColumns";
import TableReload from "./TableReload";
import { useGridRootProps } from "@mui/x-data-grid-pro";
import TableFilter from "./TableFilter";
import TableMoreActions from "./TableMoreActions";
import TableSorter from "./TableSorter";

const TableToolbar = () => {
  const {
    tableId,
    pageName,
    noRadiusLeft,
    setLoading,
    isClient,
    pageOrderName,
    defaultSearch,
    disableSearch,
    disableFilter,
    disableVisibleColumns,
    additionalFilter,
    whiteButtons,
    toolbarActions,
    getColumnActions,
    withSorter,
    setHasQuery,
    customFilterComponent,
    autofocusSearch,
    customColumnsButton,
    onSearchChange,
  } = useGridRootProps();

  return (
    <Group
      gap={0}
      pt={8}
      mb={16}
      className="table-toolbar"
      pos={"relative"}
      style={{ zIndex: 30 }}
    >
      <TableSearch
        noRadiusLeft={noRadiusLeft}
        defaultSearch={defaultSearch}
        disabled={disableSearch}
        setHasQuery={setHasQuery}
        onSearchChange={onSearchChange}
        autofocusSearch={autofocusSearch}
      />

      {withSorter && (
        <TableSorter tableId={tableId} whiteButtons={whiteButtons} />
      )}

      {customFilterComponent}
      {!disableFilter && (
        <TableFilter
          tableId={tableId}
          pageName={pageName}
          isClient={isClient}
          additionalFilter={additionalFilter}
          whiteButtons={whiteButtons}
        />
      )}

      <Group wrap="nowrap">
        {!disableVisibleColumns && (
          <TableColumns
            pageName={pageName}
            pageOrderName={pageOrderName}
            tableId={tableId}
            whiteButtons={whiteButtons}
            getColumnActions={getColumnActions}
          />
        )}

        {customColumnsButton}
      </Group>

      {toolbarActions && (
        <TableMoreActions tableId={tableId} actions={toolbarActions} />
      )}

      <Group mt={1} mr={2} ml={whiteButtons ? "auto" : 0}>
        {setLoading && (
          <TableReload setLoading={setLoading} tableId={tableId} />
        )}
      </Group>
    </Group>
  );
};

export default TableToolbar;
